import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import {SsoService} from "../../../services/SsoService";

export const useSsoConfigurationQuery = (options?: {enabled?: boolean}) => {
  const {organizationId} = useParams<{organizationId: string}>();

  return useQuery(
    ["ssoConfiguration", organizationId],
    async () => {
      const {data} = await SsoService.getConfiguration(organizationId);
      return data;
    },
    {
      enabled: !!organizationId,
      ...options,
    },
  );
};
